import { publicRoutes } from "Consts/auth";

export const isPublicUrl = (excludedUrls = publicRoutes) => {
  const currentEndpoint = `/${window.location.href.split("/").pop()}`;
  return excludedUrls.some((endpoint) =>
    currentEndpoint.includes(`/${endpoint}`)
  );
};
